<template>
	<div class="container">
		<div class="info">
			<div class="top"><img class="fanhuianniu" src="../../../static/images/other-fanhui.png" @click="goback" /></div>
			<div class="title"><img src="../../../static/images/jinggao.png" /></div>
			<div class="tips">您没有权限进入试题页面</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'indexpage',
	components: {},
	data() {
		return {};
	},
	created() {
		console.log('--------cantgetin-------');
	},

	methods: {
		goback() {
			var url = localStorage.getItem('h5_return_url');
			if (url) {
				if (url == 'null') {
					return;
				}
				// window.location.href =url // https%3A%2F%2Fwww.baidu.com
				var tohref = decodeURIComponent(url);
				// console.log(tohref);
				window.location.href = tohref;
				// this.$router.push({ path: url });
			}
		}
	},
	beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
//scoped
.container {
	background-color: #fff;
	height: 100vh;
	width: 100vw;
	font-size: 0.2rem;
	position: relative;
	margin: 0 auto;
	text-align: center;
	.info {
		width: 100%;
		height: 100%;
		margin: 0 auto;
		text-align: center;
		.title {
			width: 4rem;
			height: 4rem;
			margin: 0 auto;
			margin-top: 4rem;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.tips {
			font-size: 1.6rem;
			width: 60vw;
			margin: 0 auto;
			line-height: 3rem;
			padding-top: 2rem;
		}
		.top {
			height: 2.5rem;
			background-color: #54aadf;
			position: relative;
			line-height: 0.45rem;
			color: #fff;
			text-align: left;
			vertical-align: middle;
			img {
				width: 0.8rem;
				height: 1.4rem;
				margin-top: 0.45rem;
				margin-left: 0.5rem;
			}
		}
	}
}
</style>
